export const SET_LOADING_VALUE = 'SET_LOADING_VALUE'
export const setValueAction = (loadingState: any) => {
    return {
        type: SET_LOADING_VALUE,
        payload: {
            loadingFlag: loadingState.loadingFlag,
        }
    }
}   